import { ReactNode, useState } from "react";
import SlideoutMenu from "@components/SlideOutMenuV2/SlideOutMenu";

export interface EntitySlideoutProps<T> {
  isOpen: boolean;
  initialValues: T;
  title: string;
  isValid: (values: T) => boolean;
  onClose: () => void;
  onSave: (values: T) => Promise<unknown> | void;
  className?: string;
  children: (values: T, onChange: (next: T) => void) => ReactNode;
}

export function EntitySlideout<T>({
  isOpen,
  initialValues,
  title,
  isValid,
  onClose,
  onSave,
  className,
  children,
}: EntitySlideoutProps<T>): JSX.Element {
  const [values, setValues] = useState<T>(initialValues);
  const [saving, setSaving] = useState(false);
  const [prevIsOpen, setPrevIsOpen] = useState(isOpen);
  if (isOpen !== prevIsOpen) {
    setPrevIsOpen(isOpen);
    if (isOpen) setValues(initialValues);
  }

  const handleSave = async () => {
    if (!isValid(values) || saving) return;
    setSaving(true);
    try {
      await onSave(values);
    } finally {
      setSaving(false);
    }
  };

  return (
    <SlideoutMenu
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSave}
      title={title}
      actionBtnDisabled={saving || !isValid(values)}
      className={className}
    >
      {isOpen && children(values, setValues)}
    </SlideoutMenu>
  );
}

export default EntitySlideout;
